<!-- TODO refactor -->
<div class="box">
  <div class="box__input" *ngIf="uploadBoxVisible">
    <label class="form-label" for="file-input">
      <app-icon name="cloud-upload"></app-icon>
    </label>
    <input
      class="cursor-pointer"
      id="file-input"
      type="file"
      (change)="onUploadFile($event)"
      [multiple]="multipleSelection"
    />
    <span class="box__input--title" i18n>Przeciągnij plik lub kliknij, aby wybrać </span>
  </div>
  <div class="box__files">
    <div class="box__files">
      <div class="row m-0">
        <div class="box__files__file col-6" *ngFor="let item of filesToUpload; let index = index; trackBy: trackByFn">
          <div class="document-icon text-center">
            <app-icon name="file-alt"></app-icon>
          </div>
          <em class="filename">
            {{ item.name }}
          </em>
          <div class="action-btns">
            <button ndt-icon-button type="button" aria-label="Usuń" i18n-aria-label (click)="deleteFileToUpload(index)">
              <app-icon name="trash"></app-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <button
      *ngIf="filesToUpload.length"
      ndt-primary-button
      type="button"
      class="my-3"
      i18n
      (click)="uploadAttachment()"
    >
      Załaduj plik
    </button>

    <h3 class="records-header my-3" i18n>Załadowane pliki:</h3>

    <ng-container *ngIf="records.length">
      <div class="box__files">
        <div class="row m-0">
          <div
            class="box__files__file col-6 shadow-sm"
            [ngClass]="[additionalProp ? 'with-add-props' : 'no-add-props']"
            *ngFor="let record of records; trackBy: trackByFn"
          >
            <div class="document-icon text-center">
              <app-icon name="file-alt"></app-icon>
            </div>
            <em class="filename">
              {{ record[nameProp] }}
            </em>
            <em *ngIf="additionalProp" class="add-info">
              ({{ additionalProp.label + ': ' + record[additionalProp.prop] }})
            </em>
            <div class="action-btns">
              <button
                [disabled]="isSaving"
                class="me-2"
                type="button"
                aria-label="Pobierz"
                i18n-aria-label
                (click)="downloadFile(record.id, record[nameProp])"
              >
                <app-icon name="file-download"></app-icon>
              </button>
              <button class="me-2" type="button" aria-label="Audyt" i18n-aria-label [auditModal]="record">
                <app-icon name="info"></app-icon>
              </button>
              <button
                [disabled]="isSaving"
                class="me-2"
                type="button"
                aria-label="Usuń"
                i18n-aria-label
                appConfirmationModal="delete"
                (confirmed)="deleteFile(record.id)"
              >
                <app-icon name="trash"></app-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
